import React, {Fragment, useEffect, useState} from 'react';
import Files from 'react-files';
import {makeApiCall, makeApiCallDelete, makeApiCallPost} from '../../Api/makeApiCall';
import {getBooleanParamOrDefault, getStringParamOrDefault} from '../../utils/urlBuilder';
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import Page from "../Components/Page";
import {Callout} from "react-foundation";
import {CalloutColors, CalloutSizes} from "react-foundation/lib/enums";
import DownloadMarketServiceButton from "./DownloadMarketServiceButton";
import DownloadDropdownOptionsButton from "./MarketService/DownloadDropdownOptionsButton";
import {DeleteMarketPeriod} from "./DeleteMarketPeriod";
import {CopyMarketServicePeriod} from "./CopyMarketServicePeriod";
import IconDropdown from "../Components/IconDropdown";
import {toastError, toastSuccess} from "../../utils/toast";
import {toast} from "react-toastify";
import SelectDropdown from '../Components/Dropdowns/SelectDropdown';
import Modal from "react-modal";
import {RadioButtonGroup} from "../../utils/components/RadioButtonGroup";
import {getUserEmail, getUserTypeFromLocalToken, userType} from "../../auth/accessTokenValidator";
import MarketServiceContent from "./MarketService/MarketServiceContent";
import {Breadcrumbs} from '../Components/Breadcrumbs';
import {faIcons} from "../../utils/iconConstants";
import _ from "lodash";
import {getServiceDropdownOptions} from "./MarketService/sharedMarketUtils";

const MarketServicePage = () => {

    const [currentPeriodAbbreviation, setCurrentPeriodAbbreviation] = useState(undefined);
    const [marketPeriods, setMarketPeriods] = useState(undefined);
    const [selectedMarketPeriod, setSelectedMarketPeriod] = useState(undefined);
    const [showDownload, setShowDownload] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isPubSubOpen, setIsPubSubOpen] = useState(false);
    const [pubSubStatus, setPubSubStatus] = useState('Publish');
    const [isBulkUploading, setIsBulkUploading] = useState(false);

    const [outletsDropdown, setOutletsDropdown] = useState([]);
    const [accountDropdown, setAccountDropdown] = useState([]);
    const [legacyAccountTypeDropdown, setLegacyAccountTypeDropdown] = useState([]);
    const [geographyLevelDropdown, setGeographyLevelDropdown] = useState([]);
    const [accountTypeDropdown, setAccountTypeDropdown] = useState([]);
    const [geographyTypeDropdown, setGeographyTypeDropdown] = useState([]);
    const [geographyCompositionDropdown, setGeographyCompositionDropdown] = useState([]);
    const [releasabilityDropdown, setReleasabilityDropdown] = useState([]);
    const [weeklyReleasabilityDropdown, setWeeklyReleasabilityDropdown] = useState([]);
    const [measureAvailabilityDropdown, setMeasureAvailabilityDropdown] = useState([]);
    const [geoStoreLevelAllowabilityDropdown, setGeoStoreLevelAllowabilityDropdown] = useState([])
    const [decodeTablesLoading, setDecodeTablesLoading] = useState(true);
    const [outletChannelSourceMap, setOutletChannelSourceMap] = useState({});


    useEffect(() => {
        getMarketPeriodList();
        getCurrentPeriod();
        uploadToast();
    }, [])

    useEffect(() => {
        setDecodeTablesLoading(true)

        Promise.all([
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/outlets`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/accounts`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/legacyAccountType`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/geographyLevel`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/accountType`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/geographyType`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/geographyComposition`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/releasability`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/weeklyReleasability`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/measureAvailability`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/marketsGeographyStoreLevelAllowability`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/channelSource`),
        ])
            .then(([
                       outletsService,
                       accountService,
                       legacyAccountTypeService,
                       geographyLevelService,
                       accountTypeService,
                       geographyTypeService,
                       geographyCompositionService,
                       releasabilityService,
                       weeklyReleasabilityService,
                       measureAvailabilityService,
                       geoStoreLevelAllowabilityService,
                       channelSourceService,
                   ]) => {
                const channelSourceMap = {};
                outletsService.data.forEach(outlet => {
                    channelSourceMap[outlet.index] = channelSourceService.data.find(cs => cs.index === outlet.channel_source_id)?.name;
                });
                setOutletChannelSourceMap(channelSourceMap);
                setOutletsDropdown(getServiceDropdownOptions(outletsService));
                setAccountDropdown(getServiceDropdownOptions(accountService));
                setLegacyAccountTypeDropdown(getServiceDropdownOptions(legacyAccountTypeService));
                setGeographyLevelDropdown(getServiceDropdownOptions(geographyLevelService));

                setAccountTypeDropdown(getServiceDropdownOptions(accountTypeService));
                setGeographyTypeDropdown(getServiceDropdownOptions(geographyTypeService));
                setGeographyCompositionDropdown(getServiceDropdownOptions(geographyCompositionService));
                setReleasabilityDropdown(getServiceDropdownOptions(releasabilityService));
                setWeeklyReleasabilityDropdown(getServiceDropdownOptions(weeklyReleasabilityService));
                setMeasureAvailabilityDropdown(getServiceDropdownOptions(measureAvailabilityService));
                setGeoStoreLevelAllowabilityDropdown(getServiceDropdownOptions(geoStoreLevelAllowabilityService));

                setDecodeTablesLoading(false)
            })
    }, []);

    const closeDeleteModal = () => setDeleteModalOpen(false);

    const openDeleteModal = () => setDeleteModalOpen(true);

    const closePubSubModal = () => setIsPubSubOpen(false)

    const updatePubSubStatus = selected => setPubSubStatus(selected);

    async function submitPubSub() {
        const data = {status: pubSubStatus, period: selectedMarketPeriod}
        const url = `${process.env.REACT_APP_EDP_API_BASE_URL}/publishMarketUpdate`;
        closePubSubModal()
        makeApiCallPost(url, JSON.stringify(data))
            .then((response) => {
                if (response?.apiError)
                    toastError(toast, `${pubSubStatus} notification period ${selectedMarketPeriod} failed with error ${JSON.stringify(response.apiError)}`)
                else
                    toastSuccess(toast, `${pubSubStatus} notification period ${selectedMarketPeriod} successfully sent`)
            })
            .catch(e => {
                toastError(toast, `${pubSubStatus} notification period ${selectedMarketPeriod} failed with error ${JSON.stringify(e)}`)
            })

    }

    function getCurrentPeriod() {
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/timeService`, {currentPeriodQuad: true})
            .then(result => {
                setCurrentPeriodAbbreviation(result?.periodAbbreviation);
                setSelectedMarketPeriod(getStringParamOrDefault('selectedMarketPeriod', undefined) || result?.periodAbbreviation);
            });
    }

    function uploadToast() {
        if (getBooleanParamOrDefault('uploadComplete', false)) {
            toastSuccess(toast, `${getStringParamOrDefault('selectedMarketPeriod', 'Market Service')} has been successfully upload`)
        }
    }

    function getMarketPeriodList() {
        makeApolloClientCall('{ marketPeriodList }')
            .then((marketPeriods) => {
                const marketPeriodsSorted = marketPeriods
                    .marketPeriodList
                    .sort(function (a, b) {
                        return b.toLowerCase().localeCompare(a.toLowerCase());
                    })
                setMarketPeriods(marketPeriodsSorted);
            })
            .catch((error) => {
                console.error(error)
            });
    }

    function onFilesChange(files, isBulkAdd) {
        setIsBulkUploading(true)
        if (_.isEmpty(files)) {
            return;
        }
        const fileReader = new FileReader();
        fileReader.onload = (loadedFiles) => {
            return uploadCsvPostCall(loadedFiles.target.result, isBulkAdd)
                .then((results) => {
                    if (!_.isEmpty(results)) {
                        console.error('Error during CSV upload:', results);
                        toastError(toast, `Upload failed: ${JSON.stringify(results)}`);
                    }
                    else {
                        const url = `${window.location.href}?uploadComplete=true`;
                        window.location.reload();
                        window.history.pushState('', '', url);
                        return Promise.resolve();
                    }

                }).finally(() => {
                    setIsBulkUploading(false)
                });
        };

        const file = files[0];
        fileReader.readAsText(file);
    }

    function changeMarketPeriod(periodSelection, refreshMarketPeriods = false) {
        if (refreshMarketPeriods) {
            getMarketPeriodList();
        }
        setSelectedMarketPeriod(periodSelection);
    }

    function uploadCsvPostCall(fileContents, isBulkAdd) {
        const data = {data: fileContents, user: getUserEmail()};
        const bulkAddParam = isBulkAdd ? '&is_bulk_add=true' : '';
        const url = `${process.env.REACT_APP_EDP_API_BASE_URL}/marketsUpdate/?period=${selectedMarketPeriod}${bulkAddParam}`;
        return makeApiCallPost(url, JSON.stringify(data));
    }

    function deleteMarketPeriod() {
        return makeApiCallDelete(`${process.env.REACT_APP_EDP_API_BASE_URL}/markets?period=${selectedMarketPeriod}`)
            .then(() => {
                getMarketPeriodList();
                setSelectedMarketPeriod(currentPeriodAbbreviation);
                setDeleteModalOpen(false);
            });
    }

    const setDownloadTo = () => setShowDownload(!showDownload);

    const theCurrentPeriodIsSelected = selectedMarketPeriod === currentPeriodAbbreviation;
    const displayWarningCurrentPeriodNotSelected = !(theCurrentPeriodIsSelected || !selectedMarketPeriod)

    const options = marketPeriods?.map(mp => ({value: mp, label: mp}));
    return (
        <Page name="Market Service" breadCrumbs={<Breadcrumbs items={[{label: 'Services'}, {label: 'Market'}]}/>}>
            {displayWarningCurrentPeriodNotSelected && <Callout
                size={CalloutSizes.SMALL}
                color={CalloutColors.WARNING}>
                <h5><i className="fa fa-exclamation-triangle"/> Current Period is not selected</h5>
            </Callout>}
            <div id={'market-service-page'}>
                <div className={'market-service-page-controls'}>
                    <div className={'left-things'}>
                        <div className={'period-selection'}>
                            <span className={'select-period'}>{'Select Period:'}</span>
                            <div className={'dropdown-wrapper'}>
                                <SelectDropdown
                                    selectValue={selectedMarketPeriod}
                                    options={options}
                                    onChange={(option) => changeMarketPeriod(option.value)}
                                />
                            </div>
                            {selectedMarketPeriod && theCurrentPeriodIsSelected
                                && <div className={'current-period-label'}>{'(Current Period)'}</div>
                            }
                        </div>
                        {
                            selectedMarketPeriod &&
                            <Fragment>
                                <IconDropdown iconName={'fa-copy'} title={"Copy To Market"}>
                                    <CopyMarketServicePeriod
                                        selectedMarketPeriod={selectedMarketPeriod}
                                        onSubmitCallback={getMarketPeriodList}
                                        path={"market/periods"}
                                    />
                                </IconDropdown>
                                <DownloadMarketServiceButton period={selectedMarketPeriod}/>
                                <div title={"Bulk Add"}>
                                    {isBulkUploading ? <i className={`${faIcons.spinner} fa-spin`}/> :
                                        <Files
                                            className={`${faIcons.fileUpload} upload files-dropzone`}
                                            onChange={(files) => onFilesChange(files, true)}
                                            accepts={['.csv']}
                                            multiple={false}
                                            maxFiles={1}
                                            maxFileSize={10000000}
                                            clickable={!isBulkUploading}
                                            disabled={isBulkUploading}
                                        >
                                            <i onClick={() => setDownloadTo()}/>
                                        </Files>
                                    }
                                </div>
                                <div title={"Bulk Update"}>
                                    {isBulkUploading ? <i className={`${faIcons.spinner} fa-spin`}/> :
                                        <Files
                                            className={`${faIcons.fileEdit} upload files-dropzone`}
                                            onChange={(files) => onFilesChange(files, false)}
                                            accepts={['.csv']}
                                            multiple={false}
                                            maxFiles={1}
                                            maxFileSize={10000000}
                                            clickable={!isBulkUploading}
                                            disabled={isBulkUploading}
                                        >
                                            <i onClick={() => setDownloadTo()}/>
                                        </Files>
                                    }
                                </div>
                                <div>
                                    {!theCurrentPeriodIsSelected &&
                                        <DeleteMarketPeriod onClick={openDeleteModal}
                                                            deleteModalOpen={deleteModalOpen}
                                                            confirmationCallback={deleteMarketPeriod}
                                                            cancellationCallback={closeDeleteModal}
                                                            selectedMarketPeriod={selectedMarketPeriod}/>
                                    }
                                </div>
                                {getUserTypeFromLocalToken() === userType.dataGovernance ? <button type={"button"}
                                                                                                   className={"button primary notification-button"}
                                                                                                   onClick={() => setIsPubSubOpen(true)}>
                                    Send Notification
                                </button> : <div/>}
                                <DownloadDropdownOptionsButton
                                    outletsDropdown={outletsDropdown}
                                    accountDropdown={accountDropdown}
                                    legacyAccountTypeDropdown={legacyAccountTypeDropdown}
                                    geographyLevelDropdown={geographyLevelDropdown}
                                    accountTypeDropdown={accountTypeDropdown}
                                    geographyTypeDropdown={geographyTypeDropdown}
                                    geographyCompositionDropdown={geographyCompositionDropdown}
                                    releasabilityDropdown={releasabilityDropdown}
                                    weeklyReleasabilityDropdown={weeklyReleasabilityDropdown}
                                    measureAvailabilityDropdown={measureAvailabilityDropdown}
                                    geoStoreLevelAllowabilityDropdown={geoStoreLevelAllowabilityDropdown}
                                />
                            </Fragment>
                        }
                    </div>

                </div>
            </div>
            <Modal
                isOpen={isPubSubOpen}
                onRequestClose={() => closePubSubModal()}
                ariaHideApp={false}
                className="Modal">
                <>
                    <div className={'modal-header'}>
                        <div><h5 className={"modal-header-text"}>Send Notification</h5></div>
                        <div>
                            <button className={"right-exit-button"} onClick={() => closePubSubModal()}>
                                <i className={faIcons.xClose}/></button>
                        </div>
                    </div>
                    <span>SND Market Metadata for {selectedMarketPeriod} has been:</span>
                    <RadioButtonGroup
                        selectedValue={pubSubStatus}
                        callback={(value) => updatePubSubStatus(value)}
                        radioButtonOptions={['Publish', 'Republish']}
                        className={'modal-radio-button-group-container'}
                        displayCheckIcon={true}
                    />

                </>
                <div className={"right-things"}>
                    <button className="button cancel modal-button" type="button" name="close"
                            onClick={() => closePubSubModal()}>
                        Cancel
                    </button>
                    <button className="button submit modal-button" type="button" name="submit"
                            onClick={() => submitPubSub()}>
                        Send
                    </button>
                </div>
            </Modal>
            <div className={'table-data'}>
                {selectedMarketPeriod && <MarketServiceContent
                    period={selectedMarketPeriod}
                    outletsDropdown={outletsDropdown}
                    accountDropdown={accountDropdown}
                    legacyAccountTypeDropdown={legacyAccountTypeDropdown}
                    geographyLevelDropdown={geographyLevelDropdown}
                    accountTypeDropdown={accountTypeDropdown}
                    geographyTypeDropdown={geographyTypeDropdown}
                    geographyCompositionDropdown={geographyCompositionDropdown}
                    releasabilityDropdown={releasabilityDropdown}
                    weeklyReleasabilityDropdown={weeklyReleasabilityDropdown}
                    measureAvailabilityDropdown={measureAvailabilityDropdown}
                    geoStoreLevelAllowabilityDropdown={geoStoreLevelAllowabilityDropdown}
                    decodeTablesLoading={decodeTablesLoading}
                    outletChannelSourceMap={outletChannelSourceMap}
                />}
            </div>
        </Page>
    )
}

export default MarketServicePage;
